var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSearch2Icon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 10a4 4 0 100-8 4 4 0 000 8zm0 2a5.973 5.973 0 003.478-1.11l4.608 4.524L16 16l-.5-2-4.608-4.525A6 6 0 106 12zm1.5-6L6 4 4.5 6 6 8l1.5-2z",
    fill: "#9A9CAC"
  })));
}

export default SvgSearch2Icon;